<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="title-section header-title input-section form-section ax-app-header-section">
              <h1 class="form-title text-center mr-0 ml-0">
                Insurance Agent / Broker / MGA<br>
                Professional Liability Application<br>
                No Known Losses or Circumstances Statement
              </h1>
            </article>

            <article class="input-section form-section">
              <div class="pt-0" >
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Firm Name:
                    </label>
                    <input
                        type="text"
                        name="firmName"
                        :value="mgaApplication.businessName"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmName')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmName') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Firm Address:
                    </label>
                    <input
                        type="text"
                        name="firmAddress"
                        :value="mgaApplication.customer.address"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmAddress')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmAddress') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                        type="text"
                        name="firmCity"
                        v-model="mgaApplication.customer.city"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmCity')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmCity') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <input
                        type="text"
                        name="firmState"
                        :value="states[mgaApplication.customer.state]"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmState')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmState') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      Zip:
                    </label>
                    <input
                        type="text"
                        name="firmZipCode"
                        :value="mgaApplication.customer.zipCode"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmZipCode')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmZipCode') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <h4 class="inputs-table-title  pt-0 mb-0" style="text-align: center;">
                CERTIFICATION OF NO KNOWN AND UNREPORTED CLAIMS OR INCIDENTS
              </h4>
              <div >
                <p class="mb-3">
                  I, the undersigned, certify that I have no knowledge of any claims, legal or otherwise, which have been, or
                  may be made, against any entity or individual for which insurance is requested, which has not been
                  reported previously to you or another insurance company. In addition, after making reasonable inquiries, I
                  am not aware of any act, error or omission, or allegations of any act, error or omissions, or any other
                  circumstances or incidents which could give rise to a claim as a result of the firm’s operations or any
                  individual’s activities on behalf of the firm. </p>
                <p class="mb-3">
                  I understand that the insurance Company’s willingness to provide coverage or reinstate coverage was
                  based on the understanding that there are no known unreported claims or incidents. I also understand that
                  all such unreported claims or incidents which later result in a claim will not be covered by the Company’s
                  policy.
                </p>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        v-model="mgaApplication.nklName"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('name')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('name') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Title
                    </label>
                    <input
                        type="text"
                        name="title"
                        v-model="mgaApplication.nklTitle"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('title')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('title') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Signature:
                    </label>
                    <input
                        type="text"
                        name="nklSignature"
                        placeholder="Type Your Name to Sign"
                        class="orep-text-input w-100"
                        v-model="mgaApplication.nklSignature"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('nklSignature')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('appSignature') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Date:
                    </label>
                    <input
                        type="date"
                        class="orep-text-input w-100 text-center"
                        :value="formattedCurrentDate()"
                        disabled
                    >
                  </div>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ibdpro-mga-application-5'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-4')"></button>
              <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-5')" :disabled="!state.pageFiveIsValid"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-7')" :disabled="!state.pageSixIsValid"></button>
            </article>
            <button
                type="submit"
                :disabled="!state.pageSixIsValid"
                :class="{submitDisabled: !state.pageSixIsValid}"
                class="next-btn mont spaced pull-right"
                @click="next()"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import { STATES } from "../../utils/constants";

export default {
  name: "ibdpro-mga-application-6",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    mgaApplication() {
      return this.$store.state.mgaApplication.mgaApplication;
    },
    state() {
      return this.$store.state.mgaApplication;
    },
    errorMsg() {
      return this.$store.state.mgaApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    next() {
      this.$router.push({
        name: "ibdpro-mga-application-7"
      });
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    navigateToPrev(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    formattedCurrentDate() {
      return moment(this.mgaApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageSixIsValid = true;
          return;
        }
        this.state.pageSixIsValid = false;
      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.page-content').offset().top
    }, 500);
  },
};
</script>

<style scoped>

</style>
